import React from 'react';
import Icon from '../AppIcon';
import { useTheme } from '../../contexts/ThemeContext';

const Footer = () => {
  const { isDarkMode } = useTheme();
  
  return (
    <footer className={`py-12 border-t ${
      isDarkMode 
        ? 'bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 border-slate-700/50' 
        : 'bg-card border-border'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                isDarkMode ? 'bg-blue-600' : 'bg-primary'
              }`}>
                <Icon name="Shirt" size={24} color="white" />
              </div>
              <div>
                <h3 className={`text-xl font-bold ${
                  isDarkMode ? 'text-white' : 'text-foreground'
                }`}>Maayo Fabric Care</h3>
                <p className={`text-sm font-inter font-extrabold tracking-brand-tag ${
                  isDarkMode ? 'text-slate-300' : 'text-muted-foreground'
                }`}>PREMIUM FABRIC CARE</p>
              </div>
            </div>
            <p className={`text-sm leading-relaxed mb-4 ${
              isDarkMode ? 'text-slate-300' : 'text-muted-foreground'
            }`}>
              Your trusted partner for premium laundry and dry cleaning services in Coimbatore. 
              We provide professional garment care with convenient pickup and delivery.
            </p>
            <div className="flex space-x-4">
              <a href="#" className={`w-10 h-10 rounded-lg flex items-center justify-center transition-smooth ${
                isDarkMode 
                  ? 'bg-slate-700/50 hover:bg-blue-600 text-slate-300 hover:text-white' 
                  : 'bg-muted hover:bg-primary hover:text-primary-foreground'
              }`}>
                <Icon name="Facebook" size={20} />
              </a>
              <a href="#" className={`w-10 h-10 rounded-lg flex items-center justify-center transition-smooth ${
                isDarkMode 
                  ? 'bg-slate-700/50 hover:bg-blue-600 text-slate-300 hover:text-white' 
                  : 'bg-muted hover:bg-primary hover:text-primary-foreground'
              }`}>
                <Icon name="Instagram" size={20} />
              </a>
              <a href="https://wa.me/919600044004" target="_blank" rel="noopener noreferrer" className={`w-10 h-10 rounded-lg flex items-center justify-center transition-smooth ${
                isDarkMode 
                  ? 'bg-slate-700/50 hover:bg-blue-600 text-slate-300 hover:text-white' 
                  : 'bg-muted hover:bg-primary hover:text-primary-foreground'
              }`}>
                <Icon name="MessageCircle" size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className={`font-semibold mb-4 ${
              isDarkMode ? 'text-white' : 'text-foreground'
            }`}>Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => window.location.href = '/home-landing'}
                  className={`transition-smooth ${
                    isDarkMode 
                      ? 'text-slate-300 hover:text-blue-400' 
                      : 'text-muted-foreground hover:text-primary'
                  }`}
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => window.location.href = '/services-overview'}
                  className={`transition-smooth ${
                    isDarkMode 
                      ? 'text-slate-300 hover:text-blue-400' 
                      : 'text-muted-foreground hover:text-primary'
                  }`}
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => window.location.href = '/pickup-scheduling'}
                  className={`transition-smooth ${
                    isDarkMode 
                      ? 'text-slate-300 hover:text-blue-400' 
                      : 'text-muted-foreground hover:text-primary'
                  }`}
                >
                  Schedule Pickup
                </button>
              </li>
              <li>
                <button
                  onClick={() => window.location.href = '/collection-points'}
                  className={`transition-smooth ${
                    isDarkMode 
                      ? 'text-slate-300 hover:text-blue-400' 
                      : 'text-muted-foreground hover:text-primary'
                  }`}
                >
                  Locations
                </button>
              </li>
              <li>
                <button
                  onClick={() => window.location.href = '/contact-us'}
                  className={`transition-smooth ${
                    isDarkMode 
                      ? 'text-slate-300 hover:text-blue-400' 
                      : 'text-muted-foreground hover:text-primary'
                  }`}
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className={`font-semibold mb-4 ${
              isDarkMode ? 'text-white' : 'text-foreground'
            }`}>Contact Info</h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-2">
                <Icon name="MapPin" size={16} color={isDarkMode ? "var(--color-slate-300)" : "var(--color-muted-foreground)"} className="flex-shrink-0 mt-0.5" />
                <div className={`text-sm ${
                  isDarkMode ? 'text-slate-300' : 'text-muted-foreground'
                }`}>
                  <p className={`font-semibold leading-relaxed ${isDarkMode ? 'text-white' : 'text-foreground'}`}>Maayo Fabric Care</p>
                  <p className="leading-relaxed">30/1, Tank Street, Velappanaickenpudur, Chinnavedampatti, Coimbatore – 641049</p>
                  <p className="leading-relaxed mt-1">Location: Thudiyalur to Saravampatti Road, Sunnambu Kalavai bus stop</p>
                </div>
              </div>
              <a href="tel:+919600044004" className="flex items-center space-x-2 group">
                <Icon name="Phone" size={16} color={isDarkMode ? "var(--color-slate-300)" : "var(--color-muted-foreground)"} className="flex-shrink-0 mt-0.5" />
                <p className={`text-sm ${
                  isDarkMode ? 'text-slate-300 group-hover:text-blue-400' : 'text-muted-foreground group-hover:text-primary'
                } transition-smooth`}>96000 44004</p>
              </a>
            </div>
          </div>
        </div>

        <div className={`border-t mt-8 pt-8 ${
          isDarkMode ? 'border-slate-700/50' : 'border-border'
        }`}>
          <div className="text-center mb-4">
            <p className={`${
              isDarkMode ? 'text-slate-300' : 'text-muted-foreground'
            }`}>
              © {new Date().getFullYear()} Maayo Fabric Care. All rights reserved. | Premium laundry services in Coimbatore
            </p>
          </div>
          <div className="text-center">
            <p className={`text-xs ${
              isDarkMode ? 'text-slate-400' : 'text-muted-foreground/70'
            }`}>
              Powered by: <a 
                href="https://thamiratech.in/" 
                target="_blank" 
                rel="noopener noreferrer"
                className={`font-medium hover:underline transition-colors ${
                  isDarkMode ? 'text-yellow-400 hover:text-yellow-300' : 'text-primary hover:text-primary/80'
                }`}
              >
                Thamira Technologies
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
